import moment from 'moment'
import api from '@/api'
import {
  normalizeAPIV2Array,
  fetchVehicleEvents,
  fetchCitimissionIsAble,
} from '@/services/events-service.js'
import eventsService from '@/services/events-service.js'
import Vue from 'vue'
import APIUrls from '@/config/simpliciti-apis'

export default {
  state: {
    events: [],
    clientCanHaveOrderGeneratedFromEvents: false,
  },
  getters: {
    getEvents(state) {
      return state.events
    },
    findEventById: (state) => (id) => {
      return state.events.find((event) => event.id === id)
    },
    clientCanHaveOrderGeneratedFromEvents(state) {
      return state.clientCanHaveOrderGeneratedFromEvents
    },
  },
  mutations: {
    setEvents(state, events) {
      state.selectedItem.events = events
      state.events = events
    },
    setClientCanHaveOrderGeneratedFromEvents(state, canOrCannot) {
      state.clientCanHaveOrderGeneratedFromEvents = canOrCannot
    },
  },
  actions: {
    async getVehicleEvents(
      { state, commit, dispatch },
      { vehicleId, datetimeFrom, filters } = {}
    ) {
      let from = moment(datetimeFrom).format('YYYY-MM-DD')

      const data = await eventsService.fetchVehicleEvents(
        vehicleId,
        [from],
        filters,
        state.clientCanHaveOrderGeneratedFromEvents
      )

      commit('setEvents', data)

      if (data && data.length) {
        dispatch(
          'simpliciti_map/setDataset',
          {
            type: 'eventsMarkers',
            data,
          },
          { root: true }
        )
      }
    },

    async isACitiMissionActiveClient({ commit }) {
      const data = await eventsService.fetchCitimissionIsAble()
      commit(
        'setClientCanHaveOrderGeneratedFromEvents',
        data.clientCanHaveOrderGeneratedFromEvents
      )
    },
  },
}
